/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * UserRole
 * User role enumeration with hierarchical permissions (set theory).
 */
export enum UserRole {
  Admin = "admin",
  Moderator = "moderator",
  Standard = "standard",
}

/**
 * TextExtractionProviderType
 * Text extraction provider types.
 */
export enum TextExtractionProviderType {
  Local = "local",
}

/**
 * RequestType
 * Types of group requests.
 */
export enum RequestType {
  JoinRequest = "join_request",
  CreateRequest = "create_request",
  InviteRequest = "invite_request",
}

/**
 * RequestStatus
 * Request processing status.
 */
export enum RequestStatus {
  Pending = "pending",
  Approved = "approved",
  Rejected = "rejected",
  Cancelled = "cancelled",
  Failed = "failed",
}

/**
 * MemberStatus
 * Membership status.
 */
export enum MemberStatus {
  Active = "active",
  Pending = "pending",
  Suspended = "suspended",
  Expired = "expired",
}

/**
 * MemberRole
 * Roles within a group.
 */
export enum MemberRole {
  Owner = "owner",
  Admin = "admin",
  Member = "member",
  Viewer = "viewer",
}

/**
 * GroupVisibility
 * Group visibility levels.
 */
export enum GroupVisibility {
  Private = "private",
  Organization = "organization",
  Public = "public",
}

/**
 * GroupType
 * Generic group types - organizations can create custom groups with any names.
 */
export enum GroupType {
  Department = "department",
  Project = "project",
  Team = "team",
  Topic = "topic",
  Role = "role",
  Functional = "functional",
  Custom = "custom",
}

/**
 * GroupStatus
 * Group lifecycle status.
 */
export enum GroupStatus {
  Active = "active",
  Inactive = "inactive",
  Archived = "archived",
  Pending = "pending",
}

/**
 * GroupSource
 * Source of the group.
 */
export enum GroupSource {
  Local = "local",
  Entra = "entra",
  Google = "google",
  Okta = "okta",
}

/**
 * FAQStatus
 * Legacy FAQ Status - wird durch ApprovalStatus ersetzt.
 */
export enum FAQStatus {
  Draft = "draft",
  PendingReview = "pending_review",
  Approved = "approved",
  Published = "published",
  Rejected = "rejected",
  Archived = "archived",
}

/**
 * FAQSortBy
 * Sortierungsoptionen für FAQ-Listen.
 */
export enum FAQSortBy {
  Newest = "newest",
  Oldest = "oldest",
  BestRated = "best_rated",
}

/**
 * EmbeddingProviderType
 * Available embedding providers.
 */
export enum EmbeddingProviderType {
  Openai = "openai",
  Azure = "azure",
  Tei = "tei",
  Ollama = "ollama",
  Huggingface = "huggingface",
}

/**
 * DocumentVisibility
 * Document visibility enumeration for hierarchical access control.
 */
export enum DocumentVisibility {
  Private = "private",
  Group = "group",
  Organization = "organization",
  Public = "public",
}

/**
 * DocumentSourceType
 * Source type of the document.
 */
export enum DocumentSourceType {
  Custom = "custom",
  Manual = "manual",
  File = "file",
  Url = "url",
  Sap = "sap",
  Faq = "faq",
  Import = "import",
  Api = "api",
}

/**
 * DocumentSourceStatus
 * Status of document source.
 */
export enum DocumentSourceStatus {
  Active = "active",
  Inactive = "inactive",
  Error = "error",
  Syncing = "syncing",
  PendingDeletion = "pending_deletion",
}

/**
 * DocumentSortBy
 * Sorting options for document lists.
 */
export enum DocumentSortBy {
  Newest = "newest",
  Oldest = "oldest",
  RecentlyUpdated = "recently_updated",
  TitleAsc = "title_asc",
  TitleDesc = "title_desc",
}

/**
 * ChatProviderType
 * Chat provider types.
 */
export enum ChatProviderType {
  Openai = "openai",
  Ollama = "ollama",
  SapAihub = "sap_aihub",
}

/**
 * AuthProviderType
 * Supported authentication provider types.
 */
export enum AuthProviderType {
  Local = "local",
  Entra = "entra",
}

/**
 * ApprovalStatus
 * Approval status for content moderation.
 */
export enum ApprovalStatus {
  Draft = "draft",
  PendingReview = "pending_review",
  Approved = "approved",
  Rejected = "rejected",
  Archived = "archived",
}

/**
 * AccessCheckResult
 * Result of an access check.
 */
export interface AccessCheckResult {
  /**
   * Has Access
   * @default false
   */
  has_access?: boolean;
  /** Access Reason */
  access_reason?: string | null;
  /**
   * Is Owner
   * @default false
   */
  is_owner?: boolean;
  /**
   * Has Multiple Owners
   * @default false
   */
  has_multiple_owners?: boolean;
  /**
   * Can Modify Permissions
   * @default false
   */
  can_modify_permissions?: boolean;
}

/**
 * AdminInit
 * Model for admin initialization.
 */
export interface AdminInit {
  /** Username */
  username: string;
  /** Password */
  password: string;
  /** Email */
  email: string;
}

/**
 * ApproverInfo
 * A user eligible to approve group requests.
 */
export interface ApproverInfo {
  /** Id */
  id: string;
  /** Username */
  username: string;
  /** Email */
  email: string;
  /** Role */
  role: string;
  /**
   * Full Name
   * @default ""
   */
  full_name?: string;
}

/**
 * AuthProviderConfigCreate
 * Model for creating auth provider configurations.
 */
export interface AuthProviderConfigCreate {
  /** Type of authentication provider */
  provider_type: AuthProviderType;
  /**
   * Is Enabled
   * Whether this provider is enabled
   * @default true
   */
  is_enabled?: boolean;
  /**
   * Is Primary
   * Whether this is the primary auth provider
   * @default false
   */
  is_primary?: boolean;
  /**
   * Config
   * Provider-specific configuration
   */
  config?: Record<string, any>;
}

/**
 * AuthProviderConfigUpdate
 * Model for updating auth provider configurations.
 */
export interface AuthProviderConfigUpdate {
  /**
   * Is Enabled
   * Whether this provider is enabled
   */
  is_enabled?: boolean | null;
  /**
   * Is Primary
   * Whether this is the primary auth provider
   */
  is_primary?: boolean | null;
  /**
   * Config
   * Provider-specific configuration
   */
  config?: Record<string, any> | null;
}

/**
 * AuthProviderResponse
 * Response model for auth provider configurations.
 */
export interface AuthProviderResponse {
  /**
   * Id
   * Provider configuration ID
   */
  id: string;
  /** Type of authentication provider */
  provider_type: AuthProviderType;
  /**
   * Is Enabled
   * Whether this provider is enabled
   */
  is_enabled: boolean;
  /**
   * Is Primary
   * Whether this is the primary auth provider
   */
  is_primary: boolean;
  /**
   * Config
   * Provider-specific configuration (secrets masked)
   */
  config: Record<string, any>;
  /**
   * Created At
   * Creation timestamp
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * Last update timestamp
   * @format date-time
   */
  updated_at: string;
}

/** Body_login_for_access_token_api_auth_token_post */
export interface BodyLoginForAccessTokenApiAuthTokenPost {
  /** Grant Type */
  grant_type?: string | null;
  /** Username */
  username: string;
  /**
   * Password
   * @format password
   */
  password: string;
  /**
   * Scope
   * @default ""
   */
  scope?: string;
  /** Client Id */
  client_id?: string | null;
  /**
   * Client Secret
   * @format password
   */
  client_secret?: string | null;
}

/** Body_parse_pfx_api_document_sources_admin_parse_pfx_post */
export interface BodyParsePfxApiDocumentSourcesAdminParsePfxPost {
  /** File */
  file: File | Blob;
  /** Passphrase */
  passphrase?: string | null;
}

/** Body_update_document_file_api_documents__document_id__file_put */
export interface BodyUpdateDocumentFileApiDocumentsDocumentIdFilePut {
  /** File */
  file: File | Blob;
  /** Title */
  title?: string | null;
  /** Visibility */
  visibility?: string | null;
  /** Tags */
  tags?: string | null;
  /** Shared With Users */
  shared_with_users?: string | null;
  /** Shared With Groups */
  shared_with_groups?: string | null;
}

/** Body_update_document_permissions_api_documents__document_id__permissions_put */
export interface BodyUpdateDocumentPermissionsApiDocumentsDocumentIdPermissionsPut {
  /** Visibility */
  visibility?: string | null;
  /** Shared With Users */
  shared_with_users?: string | null;
  /** Shared With Groups */
  shared_with_groups?: string | null;
}

/** Body_upload_document_api_documents_upload_post */
export interface BodyUploadDocumentApiDocumentsUploadPost {
  /** File */
  file: File | Blob;
  /** Title */
  title?: string | null;
  /**
   * Category
   * @default "general"
   */
  category?: string | null;
  /** Tags */
  tags?: string | null;
  /**
   * Visibility
   * @default "private"
   */
  visibility?: string | null;
  /** Shared With Users */
  shared_with_users?: string | null;
  /** Shared With Groups */
  shared_with_groups?: string | null;
  /**
   * Legal Basis
   * @default "legitimate_interest"
   */
  legal_basis?: string | null;
  /**
   * On Duplicate
   * @default "prompt"
   */
  on_duplicate?: string;
}

/**
 * BulkDeleteConversationsRequest
 * Request model for bulk conversation deletion.
 */
export interface BulkDeleteConversationsRequest {
  /**
   * Conversation Ids
   * @maxItems 100
   * @minItems 1
   */
  conversation_ids: string[];
}

/**
 * BulkDeleteConversationsResponse
 * Response model for bulk conversation deletion.
 */
export interface BulkDeleteConversationsResponse {
  /** Status */
  status: string;
  /** Total Requested */
  total_requested: number;
  /** Successful Count */
  successful_count: number;
  /** Failed Count */
  failed_count: number;
  /** Results */
  results: BulkDeleteResult[];
}

/**
 * BulkDeleteResult
 * Result for a single conversation deletion.
 */
export interface BulkDeleteResult {
  /** Conversation Id */
  conversation_id: string;
  /** Success */
  success: boolean;
  /** Error */
  error?: string | null;
}

/** BulkDocumentDeleteRequest */
export interface BulkDocumentDeleteRequest {
  /**
   * Document Ids
   * @maxItems 100
   * @minItems 1
   */
  document_ids: string[];
  /** Reason */
  reason?: string | null;
}

/**
 * BulkDocumentPermissionsRequest
 * Set the same sharing on several documents at once.
 *
 * A field left out keeps what each document has; an empty list clears it
 * (the same contract as the single ``PUT /{id}/permissions``).
 */
export interface BulkDocumentPermissionsRequest {
  /**
   * Document Ids
   * @maxItems 100
   * @minItems 1
   */
  document_ids: string[];
  visibility?: DocumentVisibility | null;
  /** Shared With Users */
  shared_with_users?: string[] | null;
  /** Shared With Groups */
  shared_with_groups?: string[] | null;
}

/**
 * BulkDocumentResult
 * Outcome for one document of a bulk action. A document the caller may not
 * touch is reported here, never silently skipped.
 */
export interface BulkDocumentResult {
  /** Document Id */
  document_id: string;
  /** Success */
  success: boolean;
  /** Error */
  error?: string | null;
}

/** BulkDocumentsResponse */
export interface BulkDocumentsResponse {
  /** Results */
  results: BulkDocumentResult[];
  /** Succeeded */
  succeeded: number;
  /** Failed */
  failed: number;
}

/**
 * BulkExportConversationsRequest
 * Request model for exporting several conversations as one archive.
 *
 * The same 1-100 bound as the bulk delete beside it: a hundred conversations
 * already make a large archive, and the endpoint reads each one separately.
 */
export interface BulkExportConversationsRequest {
  /**
   * Conversation Ids
   * @maxItems 100
   * @minItems 1
   */
  conversation_ids: string[];
  /**
   * Format
   * md keeps the structure, txt is plain text
   * @default "md"
   */
  format?: "md" | "txt";
}

/**
 * CanShareResponse
 * Whether the current user may share a document with a group, and why.
 */
export interface CanShareResponse {
  /** Can Share */
  can_share: boolean;
  /** Reason */
  reason: string;
}

/**
 * ChatConfigRequest
 * Request model for chat configuration.
 */
export interface ChatConfigRequest {
  /** Chat provider types. */
  provider_type: ChatProviderType;
  /** Display Name */
  display_name: string;
  /**
   * Description
   * @default ""
   */
  description?: string;
  /** Model */
  model: string;
  /**
   * Temperature
   * @default 0.7
   */
  temperature?: number;
  /**
   * Max Tokens
   * @default 1000
   */
  max_tokens?: number;
  /**
   * Timeout
   * @default 30
   */
  timeout?: number;
  /**
   * Streaming
   * @default true
   */
  streaming?: boolean;
  /**
   * System Message
   * @default ""
   */
  system_message?: string;
  /** Provider Config */
  provider_config?: Record<string, string | number | boolean | string[]>;
  /**
   * Is Default
   * @default false
   */
  is_default?: boolean;
}

/**
 * ChatConfigResponse
 * Response model for chat configuration.
 */
export interface ChatConfigResponse {
  /**
   * Id
   * @default ""
   */
  id?: string;
  /** Chat provider types. */
  provider_type: ChatProviderType;
  /** Display Name */
  display_name: string;
  /** Description */
  description: string;
  /** Model */
  model: string;
  /** Temperature */
  temperature: number;
  /** Max Tokens */
  max_tokens: number;
  /** Timeout */
  timeout: number;
  /** Streaming */
  streaming: boolean;
  /** System Message */
  system_message: string;
  /** Provider Config */
  provider_config?: Record<string, string | number | boolean | string[]>;
  /** Is Active */
  is_active: boolean;
  /** Is Default */
  is_default: boolean;
  /**
   * Created By
   * @default ""
   */
  created_by?: string;
  /**
   * Updated By
   * @default ""
   */
  updated_by?: string;
  /** Created At */
  created_at?: string | null;
  /** Updated At */
  updated_at?: string | null;
}

/**
 * ChatConfigTest
 * Model for testing chat configuration.
 */
export interface ChatConfigTest {
  /** Success */
  success: boolean;
  /** Message */
  message: string;
  /** Error */
  error?: string | null;
  /** Provider Type */
  provider_type?: string | null;
  /** Test Result */
  test_result?: Record<string, any>;
}

/**
 * ChatMessage
 * Model for chat messages.
 */
export interface ChatMessage {
  /** Role */
  role: string;
  /** Content */
  content: string;
}

/**
 * ChatProviderResponse
 * Response model for chat provider information.
 */
export interface ChatProviderResponse {
  /** Value */
  value: string;
  /** Label */
  label: string;
  /** Description */
  description: string;
  /**
   * Default Model
   * @default ""
   */
  default_model?: string;
  /**
   * Default Models
   * @default []
   */
  default_models?: string[];
  /**
   * Features
   * @default []
   */
  features?: string[];
  /** Required Config */
  required_config: string[];
  /** Optional Config */
  optional_config: string[];
  /**
   * Config Fields
   * @default {}
   */
  config_fields?: Record<string, any>;
  /** Is Active */
  is_active: boolean;
}

/**
 * ChatRequest
 * Model for chat API requests.
 */
export interface ChatRequest {
  /** Messages */
  messages: ChatMessage[];
  /**
   * Stream
   * @default false
   */
  stream?: boolean;
  /**
   * Max Tokens
   * @default 1000
   */
  max_tokens?: number | null;
  /**
   * Temperature
   * @default 0.7
   */
  temperature?: number | null;
  /** Metadata Filters */
  metadata_filters?: Record<string, string> | null;
}

/**
 * ConnectionSyncStatus
 * Per-connection sync status returned by the user sync-status endpoint.
 */
export interface ConnectionSyncStatus {
  /** Connection Id */
  connection_id: string;
  /** Status */
  status: string;
  /** Last Sync At */
  last_sync_at?: string | null;
  /** Last Successful Sync At */
  last_successful_sync_at?: string | null;
  /**
   * Error Count
   * @default 0
   */
  error_count?: number;
  /** Last Error */
  last_error?: string | null;
}

/**
 * ConnectionSyncStatusDetail
 * Per-connection sync status as embedded in the admin aggregate view.
 *
 * Adds the connection name, owning user, and external-ingest stats that the
 * admin sync-status endpoint includes for each connection under a provider
 * config.
 */
export interface ConnectionSyncStatusDetail {
  /** Connection Id */
  connection_id: string;
  /** Status */
  status: string;
  /** Last Sync At */
  last_sync_at?: string | null;
  /** Last Successful Sync At */
  last_successful_sync_at?: string | null;
  /**
   * Error Count
   * @default 0
   */
  error_count?: number;
  /** Last Error */
  last_error?: string | null;
  /** Name */
  name?: string | null;
  /** User Id */
  user_id?: string | null;
  /** External Ingest Stats */
  external_ingest_stats?: Record<string, any>;
  /** Source Label */
  source_label?: string | null;
  /** Source Detail */
  source_detail?: string | null;
  /**
   * Sync State
   * @default "idle"
   */
  sync_state?: string;
  /** Sync Started At */
  sync_started_at?: string | null;
  /** Sync Heartbeat At */
  sync_heartbeat_at?: string | null;
  /** Sync Progress */
  sync_progress?: Record<string, any>;
  /** Sync Interval */
  sync_interval?: string | null;
  /**
   * Sync Retry Count
   * @default 0
   */
  sync_retry_count?: number;
}

/**
 * ConversationDetails
 * Full conversation details including messages.
 */
export interface ConversationDetails {
  /** Id */
  id: string;
  /** Title */
  title: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Message Count */
  message_count: number;
  /** Is Archived */
  is_archived: boolean;
  /** Tools Enabled */
  tools_enabled: boolean;
  /** Last Message Preview */
  last_message_preview?: string | null;
  /** Messages */
  messages?: Record<string, any>[];
}

/**
 * ConversationSummary
 * Lightweight conversation info for lists.
 */
export interface ConversationSummary {
  /** Id */
  id: string;
  /** Title */
  title: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Message Count */
  message_count: number;
  /** Is Archived */
  is_archived: boolean;
  /** Tools Enabled */
  tools_enabled: boolean;
  /** Last Message Preview */
  last_message_preview?: string | null;
}

/**
 * CreateConversationRequest
 * Request model for creating a new conversation with input validation.
 */
export interface CreateConversationRequest {
  /**
   * Title
   * Conversation title
   * @default "Neuer Chat"
   */
  title?: string | null;
}

/**
 * Document
 * Read-side model for stored document data.
 *
 * Legacy fields (``processed``, ``processing_status``, ``chunk_count``,
 * etc.) are dropped from this schema.  The model REJECTS documents that carry
 * any trimmed field (see ``_PHASE_5C_TRIMMED_FIELDS``).  Legacy MongoDB rows
 * that were never migrated will raise ``ValidationError``.  Fresh ingests via
 * the orchestrator pipeline are unaffected (they never write these fields).
 */
export interface Document {
  /** Title */
  title?: string | null;
  /** Url */
  url?: string | null;
  /** @default "private" */
  visibility?: DocumentVisibility | null;
  /**
   * Source type of the document.
   * @default "custom"
   */
  source_type?: DocumentSourceType;
  /**
   * Approval status for content moderation.
   * @default "draft"
   */
  approval_status?: ApprovalStatus;
  /**
   * Shared With Users
   * @default []
   */
  shared_with_users?: string[];
  /**
   * Shared With Groups
   * @default []
   */
  shared_with_groups?: string[];
  /**
   * Approved By
   * User-ID des Genehmigers
   */
  approved_by?: string | null;
  /**
   * Approved At
   * Zeitpunkt der Genehmigung
   */
  approved_at?: string | null;
  /**
   * Rejection Reason
   * Grund der Ablehnung
   */
  rejection_reason?: string | null;
  /** Document Id */
  document_id: string;
  /**
   * Content
   * @default ""
   */
  content?: string;
  /**
   * Status
   * @default "pending"
   */
  status?: string;
  /** Indexed At */
  indexed_at?: string | null;
  /** Error Message */
  error_message?: string | null;
  /** Failure Reason */
  failure_reason?: string | null;
  /** Processing Note */
  processing_note?: string | null;
  /**
   * Failure Count
   * @default 0
   */
  failure_count?: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Metadata */
  metadata?: Record<string, any>;
  /** File Type */
  file_type?: string | null;
  /** User Id */
  user_id?: string | null;
  /** Owner Id */
  owner_id?: string | null;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  /** Owner Username */
  owner_username?: string | null;
  /** Owner Email */
  owner_email?: string | null;
  /** Owner Full Name */
  owner_full_name?: string | null;
  /**
   * Shared With Users Details
   * @default []
   */
  shared_with_users_details?: Record<string, string>[] | null;
  /**
   * Shared With Groups Details
   * @default []
   */
  shared_with_groups_details?: Record<string, string>[] | null;
}

/**
 * DocumentCreate
 * Write-side model for document creation and update.
 *
 * ``extra="forbid"`` ensures any attempt to pass removed legacy fields
 * (``processed``, ``processing_status``, ``chunk_count``, etc.) raises
 * ``ValidationError`` loudly instead of silently accepting them.
 *
 * ``text_extraction_provider`` is accepted here (input context) but is NOT
 * persisted into the stored ``Document`` model.
 */
export interface DocumentCreate {
  /** Title */
  title?: string | null;
  /** Url */
  url?: string | null;
  /** @default "private" */
  visibility?: DocumentVisibility | null;
  /**
   * Source type of the document.
   * @default "custom"
   */
  source_type?: DocumentSourceType;
  /**
   * Approval status for content moderation.
   * @default "draft"
   */
  approval_status?: ApprovalStatus;
  /**
   * Shared With Users
   * User-IDs für spezifisches Sharing
   */
  shared_with_users?: string[];
  /**
   * Shared With Groups
   * Gruppe-IDs für GROUP visibility
   */
  shared_with_groups?: string[];
  /**
   * Approved By
   * User-ID des Genehmigers
   */
  approved_by?: string | null;
  /**
   * Approved At
   * Zeitpunkt der Genehmigung
   */
  approved_at?: string | null;
  /**
   * Rejection Reason
   * Grund der Ablehnung
   */
  rejection_reason?: string | null;
  /** Content */
  content?: string | null;
  /** File Type */
  file_type?: string | null;
  /** Text Extraction Provider */
  text_extraction_provider?: string | null;
}

/**
 * DocumentListResponse
 * Response model for paginated document list.
 */
export interface DocumentListResponse {
  /** Documents */
  documents: Document[];
  /** Total */
  total: number;
}

/**
 * DocumentSourceProviderConfigRequest
 * Request model for admin-level provider configuration.
 */
export interface DocumentSourceProviderConfigRequest {
  /** Provider Type */
  provider_type: string;
  /** Name */
  name: string;
  /**
   * Enabled
   * @default true
   */
  enabled?: boolean;
  /** Description */
  description?: string | null;
  /** Provider Config */
  provider_config?: Record<string, any> | null;
  /** Provider Key */
  provider_key: string;
  /** Initial Connection */
  initial_connection?: Record<string, any> | null;
}

/**
 * DocumentSourceProviderConfigResponse
 * Response model for admin-level provider configurations.
 */
export interface DocumentSourceProviderConfigResponse {
  /** Id */
  id: string;
  /** Provider Type */
  provider_type: string;
  /** Provider Key */
  provider_key: string;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Enabled */
  enabled: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by: string;
  /** Config Schema */
  config_schema?: Record<string, any> | null;
  /** User Config Schema */
  user_config_schema?: Record<string, any> | null;
  /** Schemas */
  schemas?: Record<string, any> | null;
  /** Provider Config */
  provider_config?: Record<string, any> | null;
  /** Secrets Set */
  secrets_set?: string[];
}

/**
 * DocumentSourceSyncStatsResponse
 * Response model for sync statistics.
 */
export interface DocumentSourceSyncStatsResponse {
  /** User Connection Id */
  user_connection_id: string;
  /** Total Files */
  total_files: number;
  /** Processed Files */
  processed_files: number;
  /** Pending Files */
  pending_files: number;
  /** Failed Files */
  failed_files: number;
  /** Last Sync Duration */
  last_sync_duration?: number | null;
  /** Average Sync Duration */
  average_sync_duration?: number | null;
  /**
   * Total Size Processed
   * @default 0
   */
  total_size_processed?: number;
}

/**
 * DocumentSourceUserConnectionRequest
 * Request model for user-specific document source connection.
 */
export interface DocumentSourceUserConnectionRequest {
  /** Provider Config Id */
  provider_config_id: string;
  /** Name */
  name: string;
  /**
   * Enabled
   * @default true
   */
  enabled?: boolean;
  /**
   * Sync Interval
   * @default "daily"
   */
  sync_interval?: string;
  /** File Filters */
  file_filters?: string[];
  /**
   * Max File Size
   * @default 52428800
   */
  max_file_size?: number;
  /**
   * Retry Attempts
   * @default 5
   */
  retry_attempts?: number;
  /**
   * Retry Delay
   * @default 60
   */
  retry_delay?: number;
  /**
   * Debounce Seconds
   * @default 10
   */
  debounce_seconds?: number;
  /**
   * Folder Path
   * @default "/"
   */
  folder_path?: string;
  /** Share Url */
  share_url?: string | null;
  /** User Provider Config */
  user_provider_config?: Record<string, any> | null;
}

/**
 * DocumentSourceUserConnectionResponse
 * Response model for user-specific document source connections.
 */
export interface DocumentSourceUserConnectionResponse {
  /** Id */
  id: string;
  /** Provider Config Id */
  provider_config_id: string;
  /** Provider Type */
  provider_type: string;
  /** Provider Key */
  provider_key: string;
  /** Provider Name */
  provider_name: string;
  /** User Id */
  user_id: string;
  /** Name */
  name: string;
  /** Enabled */
  enabled: boolean;
  /** Status of document source. */
  status: DocumentSourceStatus;
  /** Sync Interval */
  sync_interval: string;
  /** File Filters */
  file_filters: string[];
  /** Max File Size */
  max_file_size: number;
  /** Retry Attempts */
  retry_attempts: number;
  /** Retry Delay */
  retry_delay: number;
  /** Debounce Seconds */
  debounce_seconds: number;
  /** Folder Path */
  folder_path: string;
  /** Share Url */
  share_url?: string | null;
  /** Last Sync At */
  last_sync_at?: string | null;
  /** Last Successful Sync At */
  last_successful_sync_at?: string | null;
  /**
   * Error Count
   * @default 0
   */
  error_count?: number;
  /** Last Error */
  last_error?: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** User Provider Config */
  user_provider_config?: Record<string, any> | null;
}

/**
 * EligibleApproversResponse
 * List of users eligible to approve group requests (admins/moderators).
 */
export interface EligibleApproversResponse {
  /** Approvers */
  approvers?: ApproverInfo[];
  /** Total */
  total: number;
}

/**
 * EmailVerification
 * Model for email verification token.
 */
export interface EmailVerification {
  /** Token */
  token: string;
}

/**
 * EmbeddingConfig
 * Configuration for embedding services.
 */
export interface EmbeddingConfig {
  /** Available embedding providers. */
  provider: EmbeddingProviderType;
  /** Model */
  model: string;
  /** Vector Size */
  vector_size: number;
  /**
   * Batch Size
   * @min 1
   * @max 1000
   * @default 100
   */
  batch_size?: number;
  /**
   * Timeout
   * @min 1
   * @max 300
   * @default 30
   */
  timeout?: number;
  /**
   * Max Retries
   * @min 0
   * @max 10
   * @default 3
   */
  max_retries?: number;
  /** Base Url */
  base_url?: string | null;
  /** Provider Config */
  provider_config?: Record<string, any>;
  /** Id */
  id?: string | null;
  /** Display Name */
  display_name?: string | null;
  /** Description */
  description?: string | null;
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean;
  /** Created By */
  created_by?: string | null;
  /** Updated By */
  updated_by?: string | null;
}

/**
 * EmbeddingProviderResponse
 * Response model for embedding provider information.
 */
export interface EmbeddingProviderResponse {
  /** Available embedding providers. */
  value: EmbeddingProviderType;
  /** Label */
  label: string;
  /** Description */
  description: string;
  /** Default Model */
  default_model: string;
  /** Default Vector Size */
  default_vector_size: number;
  /** Required Config */
  required_config: string[];
  /** Optional Config */
  optional_config: string[];
  /** Is Active */
  is_active: boolean;
}

/**
 * EmbeddingTestResponse
 * Response model for embedding configuration test.
 */
export interface EmbeddingTestResponse {
  /** Success */
  success: boolean;
  /** Message */
  message: string;
  /**
   * Error
   * @default ""
   */
  error?: string;
  /**
   * Test Results
   * @default {}
   */
  test_results?: Record<string, any>;
}

/**
 * FAQDocumentCreate
 * Model für FAQ-Erstellung als Document.
 */
export interface FAQDocumentCreate {
  /** Title */
  title?: string | null;
  /** Url */
  url?: string | null;
  /**
   * Document visibility enumeration for hierarchical access control.
   * @default "organization"
   */
  visibility?: DocumentVisibility;
  /**
   * Source Type
   * @default "faq"
   */
  source_type?: string;
  /**
   * Approval status for content moderation.
   * @default "draft"
   */
  approval_status?: ApprovalStatus;
  /**
   * Shared With Users
   * User-IDs für spezifisches Sharing
   */
  shared_with_users?: string[];
  /**
   * Shared With Groups
   * Gruppe-IDs für GROUP visibility
   */
  shared_with_groups?: string[];
  /**
   * Approved By
   * User-ID des Genehmigers
   */
  approved_by?: string | null;
  /**
   * Approved At
   * Zeitpunkt der Genehmigung
   */
  approved_at?: string | null;
  /**
   * Rejection Reason
   * Grund der Ablehnung
   */
  rejection_reason?: string | null;
  /** Content */
  content?: string | null;
  /**
   * File Type
   * @default "text"
   */
  file_type?: string;
  /** Text Extraction Provider */
  text_extraction_provider?: string | null;
  /**
   * Question
   * Die FAQ Frage
   * @minLength 10
   * @maxLength 500
   */
  question: string;
  /**
   * Answer
   * Die ausführliche Antwort
   * @minLength 20
   */
  answer: string;
  /**
   * Category Tags
   * Kategorie-Tags
   */
  category_tags?: string[];
  /**
   * Language
   * Sprache
   * @default "de"
   */
  language?: string;
}

/**
 * FAQDocumentResponse
 * Response Model für FAQ als Document.
 */
export interface FAQDocumentResponse {
  /** Title */
  title?: string | null;
  /** Url */
  url?: string | null;
  /** @default "private" */
  visibility?: DocumentVisibility | null;
  /**
   * Source type of the document.
   * @default "custom"
   */
  source_type?: DocumentSourceType;
  /**
   * Approval status for content moderation.
   * @default "draft"
   */
  approval_status?: ApprovalStatus;
  /**
   * Shared With Users
   * @default []
   */
  shared_with_users?: string[];
  /**
   * Shared With Groups
   * @default []
   */
  shared_with_groups?: string[];
  /**
   * Approved By
   * User-ID des Genehmigers
   */
  approved_by?: string | null;
  /**
   * Approved At
   * Zeitpunkt der Genehmigung
   */
  approved_at?: string | null;
  /**
   * Rejection Reason
   * Grund der Ablehnung
   */
  rejection_reason?: string | null;
  /** Document Id */
  document_id: string;
  /**
   * Content
   * @default ""
   */
  content?: string;
  /**
   * Status
   * @default "pending"
   */
  status?: string;
  /** Indexed At */
  indexed_at?: string | null;
  /** Error Message */
  error_message?: string | null;
  /** Failure Reason */
  failure_reason?: string | null;
  /** Processing Note */
  processing_note?: string | null;
  /**
   * Failure Count
   * @default 0
   */
  failure_count?: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Metadata */
  metadata?: Record<string, any>;
  /** File Type */
  file_type?: string | null;
  /** User Id */
  user_id?: string | null;
  /** Owner Id */
  owner_id?: string | null;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  /** Owner Username */
  owner_username?: string | null;
  /** Owner Email */
  owner_email?: string | null;
  /** Owner Full Name */
  owner_full_name?: string | null;
  /**
   * Shared With Users Details
   * @default []
   */
  shared_with_users_details?: Record<string, string>[] | null;
  /**
   * Shared With Groups Details
   * @default []
   */
  shared_with_groups_details?: Record<string, string>[] | null;
  /**
   * Question
   * @default ""
   */
  question?: string;
  /**
   * Answer
   * @default ""
   */
  answer?: string;
  /**
   * Language
   * @default "de"
   */
  language?: string;
  /**
   * Legacy FAQ Status - wird durch ApprovalStatus ersetzt.
   * @default "draft"
   */
  faq_status?: FAQStatus;
  /**
   * Category Tags
   * @default []
   */
  category_tags?: string[];
  /**
   * View Count
   * @default 0
   */
  view_count?: number;
  /**
   * Helpful Count
   * @default 0
   */
  helpful_count?: number;
  /**
   * Not Helpful Count
   * @default 0
   */
  not_helpful_count?: number;
  /**
   * Allow Rating
   * @default true
   */
  allow_rating?: boolean;
  /**
   * Allow Comments
   * @default false
   */
  allow_comments?: boolean;
  /** User Vote */
  user_vote?: string | null;
}

/**
 * FAQDocumentUpdate
 * Model für FAQ-Updates.
 */
export interface FAQDocumentUpdate {
  /** Question */
  question?: string | null;
  /** Answer */
  answer?: string | null;
  /** Category Tags */
  category_tags?: string[] | null;
  /** Language */
  language?: string | null;
  visibility?: DocumentVisibility | null;
  /** Shared With Users */
  shared_with_users?: string[] | null;
  /** Shared With Groups */
  shared_with_groups?: string[] | null;
}

/**
 * FAQListResponse
 * Response für FAQ Listen.
 */
export interface FAQListResponse {
  /** Faqs */
  faqs: FAQDocumentResponse[];
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Has Next */
  has_next: boolean;
}

/**
 * FAQPendingCountResponse
 * Just the number behind the navigation badge.
 *
 * Separate from FAQStatsResponse so the badge does not pull the whole
 * statistic (twelve queries) for a single integer it polls constantly.
 */
export interface FAQPendingCountResponse {
  /** Pending Review */
  pending_review: number;
}

/**
 * FAQSearchResponse
 * Response für FAQ Suche.
 */
export interface FAQSearchResponse {
  /** Faqs */
  faqs: FAQDocumentResponse[];
  /** Query */
  query: string;
  /** Total Results */
  total_results: number;
  /** Search Time Ms */
  search_time_ms: number;
}

/**
 * FAQStatsResponse
 * Response für FAQ Statistiken.
 */
export interface FAQStatsResponse {
  /** Total Faqs */
  total_faqs: number;
  /** Pending Review */
  pending_review: number;
  /** Published Faqs */
  published_faqs: number;
  /** Rejected Faqs */
  rejected_faqs: number;
  /** Approved Faqs */
  approved_faqs: number;
  /** Draft Faqs */
  draft_faqs: number;
  /** Archived Faqs */
  archived_faqs: number;
  /** Most Viewed */
  most_viewed: FAQDocumentResponse[];
  /** Most Helpful */
  most_helpful: FAQDocumentResponse[];
  /** Categories */
  categories: Record<string, number>;
  /** Recent Activity */
  recent_activity: Record<string, number>;
}

/**
 * FAQStatusUpdate
 * Model for FAQ status updates.
 */
export interface FAQStatusUpdate {
  /** Legacy FAQ Status - wird durch ApprovalStatus ersetzt. */
  status: FAQStatus;
  /** Rejection Reason */
  rejection_reason?: string | null;
  /**
   * Auto Publish
   * @default true
   */
  auto_publish?: boolean;
}

/**
 * FolderSync
 * Folder sync response model.
 */
export interface FolderSync {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Provider */
  provider: string;
  /** Url */
  url: string;
  /** Description */
  description: string | null;
  /** Folder sync configuration. */
  configuration: FolderSyncConfig;
  /** Status */
  status: string;
  /** Last Sync At */
  last_sync_at: string | null;
  /** Sync Stats */
  sync_stats: Record<string, any>;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/**
 * FolderSyncConfig
 * Folder sync configuration.
 */
export interface FolderSyncConfig {
  /**
   * Ssl Verify
   * @default true
   */
  ssl_verify?: boolean;
  /** Selected Files */
  selected_files?: string[] | null;
  /**
   * Sync Subfolders
   * @default true
   */
  sync_subfolders?: boolean;
  /**
   * Default Visibility
   * @default "private"
   */
  default_visibility?: string;
  /**
   * Default Shared With Groups
   * @default []
   */
  default_shared_with_groups?: string[];
  /**
   * Default Shared With Users
   * @default []
   */
  default_shared_with_users?: string[];
  /**
   * Remove Deleted Files
   * @default true
   */
  remove_deleted_files?: boolean;
  /**
   * Update Changed Files
   * @default true
   */
  update_changed_files?: boolean;
  /**
   * Preserve User Changes
   * @default false
   */
  preserve_user_changes?: boolean;
}

/**
 * FolderSyncCreate
 * Create folder sync request.
 */
export interface FolderSyncCreate {
  /** Name */
  name: string;
  /** Provider */
  provider: string;
  /** Url */
  url: string;
  /** Description */
  description?: string | null;
  /** Folder sync configuration. */
  configuration: FolderSyncConfig;
}

/**
 * FolderSyncUpdate
 * Update folder sync request.
 */
export interface FolderSyncUpdate {
  /** Name */
  name?: string | null;
  /** Description */
  description?: string | null;
  configuration?: FolderSyncConfig | null;
  /** Status */
  status?: string | null;
}

/**
 * Group
 * Complete group model with Azure AD compatibility and set-theory based hierarchy support.
 * @example {"admins":["user123","user456"],"created_at":"2025-01-01T10:00:00Z","created_by":"system","description":"Development team for Cpro projects","displayName":"Cpro Entwickler","document_count":23,"external_id":"49913706-109e-4ea4-9e30-9a74c3c3b1a0","groupTypes":[],"id":"49913706-109e-4ea4-9e30-9a74c3c3b1a0","last_synced":"2025-01-24T10:00:00Z","mailEnabled":false,"member_count":8,"owner_id":"user123","securityEnabled":true,"settings":{"allow_document_sharing":true,"require_approval":true,"visibility":"organization"},"source":"entra","status":"active","sync_enabled":true,"tags":["development","cpro","team"],"type":"team"}
 */
export interface Group {
  /**
   * Displayname
   * Group display name (Azure AD compatible)
   * @minLength 1
   * @maxLength 256
   */
  displayName: string;
  /**
   * Description
   * Group description
   */
  description?: string | null;
  /**
   * Generic group types - organizations can create custom groups with any names.
   * @default "custom"
   */
  type?: GroupType;
  /**
   * Tags
   * @maxItems 10
   */
  tags?: string[];
  /**
   * Source of the group.
   * @default "local"
   */
  source?: GroupSource;
  /**
   * Grouptypes
   * Azure AD group types
   */
  groupTypes?: string[];
  /**
   * Securityenabled
   * Whether this is a security group
   * @default true
   */
  securityEnabled?: boolean;
  /**
   * Mailenabled
   * Whether this group is mail enabled
   * @default false
   */
  mailEnabled?: boolean;
  /**
   * Id
   * Unique group identifier - Azure AD ID for external groups, slug for local groups
   */
  id: string;
  /**
   * Group lifecycle status.
   * @default "active"
   */
  status?: GroupStatus;
  /** Owner Id */
  owner_id?: string | null;
  /** Admins */
  admins?: string[];
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Created By */
  created_by?: string | null;
  /** Updated At */
  updated_at?: string | null;
  /** Group configuration settings. */
  settings?: GroupSettings;
  /** Parent Group */
  parent_group?: string | null;
  /**
   * Child Groups
   * Direct child groups
   */
  child_groups?: string[];
  /** Metadata */
  metadata?: Record<string, string | number | boolean>;
  /**
   * External Id
   * External system ID (Azure AD GUID)
   */
  external_id?: string | null;
  /**
   * Sync Enabled
   * Whether this group is synchronized with external source
   * @default false
   */
  sync_enabled?: boolean;
  /**
   * Last Synced
   * Last synchronization timestamp
   */
  last_synced?: string | null;
  /**
   * Document Count
   * @default 0
   */
  document_count?: number;
  /** Last Activity */
  last_activity?: string | null;
  /**
   * Hierarchy Level
   * @default 0
   */
  hierarchy_level?: number;
  /**
   * All Parent Groups
   * All ancestor groups
   */
  all_parent_groups?: string[];
  /**
   * Inherited Permissions
   * Permissions from parent groups
   */
  inherited_permissions?: string[];
}

/**
 * GroupCreate
 * Model for creating a new group.
 */
export interface GroupCreate {
  /**
   * Displayname
   * Group display name (Azure AD compatible)
   * @minLength 1
   * @maxLength 256
   */
  displayName: string;
  /**
   * Description
   * Group description
   */
  description?: string | null;
  /**
   * Generic group types - organizations can create custom groups with any names.
   * @default "custom"
   */
  type?: GroupType;
  /**
   * Tags
   * @maxItems 10
   */
  tags?: string[];
  /**
   * Source of the group.
   * @default "local"
   */
  source?: GroupSource;
  /**
   * Grouptypes
   * Azure AD group types
   */
  groupTypes?: string[];
  /**
   * Securityenabled
   * Whether this is a security group
   * @default true
   */
  securityEnabled?: boolean;
  /**
   * Mailenabled
   * Whether this group is mail enabled
   * @default false
   */
  mailEnabled?: boolean;
  /** Group configuration settings. */
  settings?: GroupSettings;
  /** Initial Members */
  initial_members?: string[];
  /** Parent Group */
  parent_group?: string | null;
}

/**
 * GroupListResponse
 * Response for listing groups with pagination.
 */
export interface GroupListResponse {
  /**
   * Groups
   * Groups for current page
   */
  groups: Group[];
  /** Pagination metadata */
  pagination: PaginationInfo;
  /**
   * Summary
   * Summary statistics
   */
  summary?: Record<string, number> | null;
}

/**
 * GroupMemberListResponse
 * Response for listing group members with pagination.
 */
export interface GroupMemberListResponse {
  /**
   * Members
   * Group members for current page
   */
  members: Record<string, any>[];
  /** Pagination metadata */
  pagination: PaginationInfo;
  /**
   * Summary
   * Summary statistics
   */
  summary?: Record<string, number> | null;
}

/**
 * GroupMemberUpdate
 * Model for updating member details.
 */
export interface GroupMemberUpdate {
  role?: MemberRole | null;
  status?: MemberStatus | null;
  permissions?: GroupPermissions | null;
  /** Expires At */
  expires_at?: string | null;
  /** Notes */
  notes?: string | null;
}

/**
 * GroupPermissions
 * Member-specific permissions within a group.
 */
export interface GroupPermissions {
  /**
   * Can Share Documents
   * @default true
   */
  can_share_documents?: boolean;
  /**
   * Can Invite Members
   * @default false
   */
  can_invite_members?: boolean;
  /**
   * Can Remove Members
   * @default false
   */
  can_remove_members?: boolean;
  /**
   * Can Edit Group
   * @default false
   */
  can_edit_group?: boolean;
  /**
   * Can Manage Permissions
   * @default false
   */
  can_manage_permissions?: boolean;
}

/**
 * GroupRequest
 * Request related to groups (join, create, etc).
 */
export interface GroupRequest {
  /** Id */
  id?: string | null;
  /** Types of group requests. */
  type: RequestType;
  /** Group Id */
  group_id?: string | null;
  /** User Id */
  user_id: string;
  /**
   * Request processing status.
   * @default "pending"
   */
  status?: RequestStatus;
  /** Reason */
  reason?: string | null;
  /**
   * Requested At
   * @format date-time
   */
  requested_at?: string;
  /** Processed By */
  processed_by?: string | null;
  /** Processed At */
  processed_at?: string | null;
  /** Admin Notes */
  admin_notes?: string | null;
  /**
   * Group Name
   * Requested group name
   */
  group_name?: string | null;
  /**
   * Description
   * Group description
   */
  description?: string | null;
  /** Type of group */
  group_type?: GroupType | null;
  /** Group visibility level */
  visibility?: GroupVisibility | null;
  /**
   * Tags
   * Group tags
   */
  tags?: string[] | null;
  /**
   * Justification
   * Reason for requesting group creation
   */
  justification?: string | null;
  /**
   * Approver Ids
   * User IDs of required approvers
   */
  approver_ids?: string[] | null;
  /**
   * Initial Admin Id
   * User ID of the second group admin
   */
  initial_admin_id?: string | null;
  /**
   * Rejection Reason
   * Reason for rejection
   */
  rejection_reason?: string | null;
  /**
   * Locked By
   * User ID who has locked the request for processing
   */
  locked_by?: string | null;
  /**
   * Locked At
   * Timestamp when the request was locked
   */
  locked_at?: string | null;
}

/**
 * GroupRequestApproval
 * Model for approving or rejecting group requests.
 */
export interface GroupRequestApproval {
  /**
   * Admin Notes
   * Admin notes for the approval/rejection
   */
  admin_notes?: string | null;
  /**
   * Rejection Reason
   * Reason for rejection
   */
  rejection_reason?: string | null;
}

/**
 * GroupRequestCreate
 * Model for creating a group creation request (used by standard users to request group creation).
 * @example {"approver_ids":["admin_user_id_123"],"description":"Team for data science collaboration and projects","group_name":"Data Science Team","group_type":"team","initial_admin_id":"team_lead_user_id_456","justification":"We need a dedicated space for the data science team to collaborate on projects and share resources","tags":["data","analytics","science"],"visibility":"organization"}
 */
export interface GroupRequestCreate {
  /**
   * Group Name
   * Requested group name (must be unique)
   * @minLength 3
   * @maxLength 100
   */
  group_name: string;
  /**
   * Description
   * Group description
   */
  description?: string | null;
  /**
   * Justification
   * Reason for requesting group creation
   * @minLength 20
   * @maxLength 500
   */
  justification: string;
  /**
   * Type of group to create
   * @default "custom"
   */
  group_type?: GroupType;
  /**
   * Group visibility level
   * @default "organization"
   */
  visibility?: GroupVisibility;
  /**
   * Approver Ids
   * User IDs of required approvers (must be admin/moderator)
   * @minItems 1
   */
  approver_ids: string[];
  /**
   * Initial Admin Id
   * User ID of the second group admin (requester becomes owner). Optional: without it the approving administrator becomes the second group admin.
   */
  initial_admin_id?: string | null;
  /**
   * Tags
   * Group tags for categorization
   * @maxItems 10
   */
  tags?: string[];
}

/**
 * GroupRequestListResponse
 * Response for listing group requests with pagination.
 */
export interface GroupRequestListResponse {
  /**
   * Requests
   * Group requests for current page
   */
  requests: GroupRequest[];
  /** Pagination metadata */
  pagination: PaginationInfo;
  /**
   * Summary
   * Summary statistics
   */
  summary?: Record<string, number> | null;
}

/**
 * GroupSettings
 * Group configuration settings.
 */
export interface GroupSettings {
  /**
   * Require Approval
   * @default true
   */
  require_approval?: boolean;
  /**
   * Allow Document Sharing
   * @default true
   */
  allow_document_sharing?: boolean;
  /**
   * Members Can Invite
   * @default false
   */
  members_can_invite?: boolean;
  /**
   * Group visibility levels.
   * @default "private"
   */
  visibility?: GroupVisibility;
  /** Max Members */
  max_members?: number | null;
  /** Retention Days */
  retention_days?: number | null;
  /** Auto Accept Domains */
  auto_accept_domains?: string[];
  /** Blocked Domains */
  blocked_domains?: string[];
}

/**
 * GroupUpdate
 * Model for updating group details.
 */
export interface GroupUpdate {
  /** Display Name */
  display_name?: string | null;
  /** Description */
  description?: string | null;
  status?: GroupStatus | null;
  settings?: GroupSettings | null;
  /** Tags */
  tags?: string[] | null;
  /** Metadata */
  metadata?: Record<string, string | number | boolean> | null;
}

/**
 * GroupsPermissionDetail
 * Extended permission detail for groups feature with granular actions.
 */
export interface GroupsPermissionDetail {
  /** Is Visible */
  is_visible: boolean;
  /**
   * Create Request
   * @default false
   */
  create_request?: boolean;
  /**
   * Create Group
   * @default false
   */
  create_group?: boolean;
  /**
   * All Groups
   * @default false
   */
  all_groups?: boolean;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/**
 * McpAuditListResponse
 * A page of MCP tool-call audit entries plus the total matching count.
 */
export interface McpAuditListResponse {
  /** Items */
  items: McpToolAuditEntry[];
  /** Total */
  total: number;
  /** Limit */
  limit: number;
  /** Skip */
  skip: number;
}

/**
 * McpServerConfigCreate
 * Admin-submitted payload to register a new MCP server.
 *
 * ``organization_id`` is intentionally absent -- the service resolves it
 * from the acting admin's DB user record, never from the request body or a
 * JWT claim (S5).
 */
export interface McpServerConfigCreate {
  /** Auth Mode */
  auth_mode: "none" | "oauth_user";
  /** Oauth Issuer */
  oauth_issuer?: string | null;
  /** Oauth Authorization Endpoint */
  oauth_authorization_endpoint?: string | null;
  /** Oauth Token Endpoint */
  oauth_token_endpoint?: string | null;
  /** Oauth Client Id */
  oauth_client_id?: string | null;
  /** Oauth Scopes */
  oauth_scopes?: string[];
  /**
   * Display Name
   * @minLength 1
   * @maxLength 200
   */
  display_name: string;
  /** Server Url */
  server_url: string;
  /** Oauth Client Secret */
  oauth_client_secret?: string | null;
  /** Allowed Chat Config Ids */
  allowed_chat_config_ids?: string[];
  /**
   * Enabled
   * @default true
   */
  enabled?: boolean;
  /**
   * Server Key
   * @pattern ^[a-z0-9_-]{1,32}$
   */
  server_key: string;
}

/**
 * McpServerConfigResponse
 * Admin-facing read model. NEVER includes a secret in any form.
 *
 * ``oauth_client_secret_envelope`` is omitted from this model entirely
 * (not redacted, not nulled -- the field does not exist here), so a bug
 * that forwarded the stored document unfiltered could not leak it through
 * this response type either.
 */
export interface McpServerConfigResponse {
  /** Auth Mode */
  auth_mode: "none" | "oauth_user";
  /** Oauth Issuer */
  oauth_issuer?: string | null;
  /** Oauth Authorization Endpoint */
  oauth_authorization_endpoint?: string | null;
  /** Oauth Token Endpoint */
  oauth_token_endpoint?: string | null;
  /** Oauth Client Id */
  oauth_client_id?: string | null;
  /** Oauth Scopes */
  oauth_scopes?: string[];
  /** Id */
  id: string;
  /** Server Key */
  server_key: string;
  /** Display Name */
  display_name: string;
  /** Organization Id */
  organization_id: string;
  /** Server Url */
  server_url: string;
  /** Pinned Tool Names */
  pinned_tool_names?: string[];
  /** Pinned Tools Hash */
  pinned_tools_hash?: string | null;
  /** Allowed Chat Config Ids */
  allowed_chat_config_ids?: string[];
  /**
   * Enabled
   * @default true
   */
  enabled?: boolean;
  /**
   * Config Version
   * @default 1
   */
  config_version?: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/**
 * McpServerConfigUpdate
 * Admin-submitted full-replace update for an existing MCP server.
 *
 * ``server_key`` is not part of the update body -- see
 * ``_McpServerConfigWritable``.
 */
export interface McpServerConfigUpdate {
  /** Auth Mode */
  auth_mode: "none" | "oauth_user";
  /** Oauth Issuer */
  oauth_issuer?: string | null;
  /** Oauth Authorization Endpoint */
  oauth_authorization_endpoint?: string | null;
  /** Oauth Token Endpoint */
  oauth_token_endpoint?: string | null;
  /** Oauth Client Id */
  oauth_client_id?: string | null;
  /** Oauth Scopes */
  oauth_scopes?: string[];
  /**
   * Display Name
   * @minLength 1
   * @maxLength 200
   */
  display_name: string;
  /** Server Url */
  server_url: string;
  /** Oauth Client Secret */
  oauth_client_secret?: string | null;
  /** Allowed Chat Config Ids */
  allowed_chat_config_ids?: string[];
  /**
   * Enabled
   * @default true
   */
  enabled?: boolean;
}

/**
 * McpToolAuditEntry
 * One append-only audit row for a single MCP tool invocation.
 *
 * ``args_shape`` and ``args_hmac`` are derived from the tool call arguments
 * but never contain the arguments themselves. ``context_overlap`` flags
 * whether the argument text overlapped the retrieval context by more than a
 * configured threshold (exfiltration signal); it is computed by the caller
 * at insert time in a later phase and defaults to ``None`` until then.
 */
export interface McpToolAuditEntry {
  /**
   * Id
   * Mongo _id as a string
   */
  id?: string | null;
  /** User Id */
  user_id: string;
  /** Organization Id */
  organization_id: string;
  /** Mcp Server Id */
  mcp_server_id: string;
  /** Conversation Id */
  conversation_id: string;
  /** Message Id */
  message_id: string;
  /** Trace Id */
  trace_id: string;
  /** Tool Name */
  tool_name: string;
  /** Args Shape */
  args_shape?: Record<string, any>;
  /** Args Hmac */
  args_hmac: string;
  /**
   * Args Hmac Key Id
   * Vault key id used to derive this row's HMAC key. None only for rows written before this field existed; a verification pass must re-derive the HMAC subkey via this id, not the box's current key, since a rotation may have moved on since.
   */
  args_hmac_key_id?: string | null;
  /** Context Overlap */
  context_overlap?: boolean | number | null;
  /** Status */
  status:
    | "started"
    | "succeeded"
    | "failed"
    | "aborted"
    | "refused"
    | "unknown";
  /**
   * Started At
   * @format date-time
   */
  started_at: string;
  /** Finished At */
  finished_at?: string | null;
  /** Duration Ms */
  duration_ms?: number | null;
  /** Error Type */
  error_type?: string | null;
}

/**
 * MessageFeedbackRequest
 * Request model for rating an assistant message (thumbs up / down).
 */
export interface MessageFeedbackRequest {
  /**
   * Feedback
   * 'up' for thumbs-up, 'down' for thumbs-down, or null to clear the rating.
   */
  feedback: string | null;
}

/**
 * MessageFeedbackResponse
 * Response model after recording message feedback.
 */
export interface MessageFeedbackResponse {
  /** Message Id */
  message_id: string;
  /** Feedback */
  feedback?: string | null;
}

/**
 * MessageResponse
 * Response model for a single message.
 */
export interface MessageResponse {
  /** Id */
  id: string;
  /** Role */
  role: string;
  /** Content */
  content: string;
  /** Sources */
  sources?: Record<string, any>[] | null;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Message Index */
  message_index: number;
  /**
   * Feedback
   * User feedback on an assistant message: 'up', 'down', or null (cleared).
   */
  feedback?: string | null;
}

/**
 * OperationResponse
 * Standard response for operations that return only a human-readable message.
 *
 * Used by delete/membership/mutation endpoints whose only payload is a
 * confirmation message, so the generated API client gets a typed shape instead
 * of ``any``.
 */
export interface OperationResponse {
  /** Message */
  message: string;
}

/**
 * OrganizationUpdate
 * Model for organization updates.
 */
export interface OrganizationUpdate {
  /** Name */
  name?: string | null;
  /** Description */
  description?: string | null;
  /** Settings */
  settings?: Record<string, any> | null;
  /** Metadata */
  metadata?: Record<string, any> | null;
}

/** PaginatedResponse[ConversationSummary] */
export interface PaginatedResponseConversationSummary {
  /**
   * Items
   * Items for current page
   */
  items: ConversationSummary[];
  /** Pagination metadata */
  pagination: PaginationInfo;
  /**
   * Summary
   * Optional summary statistics
   */
  summary?: Record<string, any> | null;
}

/** PaginatedResponse[MessageResponse] */
export interface PaginatedResponseMessageResponse {
  /**
   * Items
   * Items for current page
   */
  items: MessageResponse[];
  /** Pagination metadata */
  pagination: PaginationInfo;
  /**
   * Summary
   * Optional summary statistics
   */
  summary?: Record<string, any> | null;
}

/**
 * PaginationInfo
 * Pagination metadata for list responses.
 * Provides comprehensive information about pagination state.
 */
export interface PaginationInfo {
  /**
   * Total
   * Total number of items across all pages
   * @min 0
   */
  total: number;
  /**
   * Page
   * Current page number (1-indexed)
   * @min 1
   */
  page: number;
  /**
   * Page Size
   * Number of items per page
   * @min 1
   * @max 100
   */
  page_size: number;
  /**
   * Has Next
   * Whether there is a next page
   */
  has_next: boolean;
  /**
   * Has Previous
   * Whether there is a previous page
   */
  has_previous: boolean;
  /**
   * Total Pages
   * Total number of pages
   * @min 0
   */
  total_pages: number;
}

/** ParsedPfxResponse */
export interface ParsedPfxResponse {
  /** Private Key Pem */
  private_key_pem: string;
  /** Public Certificate Pem */
  public_certificate_pem: string;
  /** Thumbprint */
  thumbprint: string;
}

/**
 * PasswordChangeRequest
 * Model for password change by authenticated user.
 */
export interface PasswordChangeRequest {
  /** Current Password */
  current_password: string;
  /** New Password */
  new_password: string;
}

/**
 * PasswordReset
 * Model for password reset request.
 */
export interface PasswordReset {
  /**
   * Email
   * @format email
   */
  email: string;
  /** Language */
  language?: string | null;
}

/**
 * PasswordResetConfirm
 * Model for password reset confirmation.
 */
export interface PasswordResetConfirm {
  /** Token */
  token: string;
  /** New Password */
  new_password: string;
}

/**
 * PermissionDetail
 * Permission detail for a specific feature.
 */
export interface PermissionDetail {
  /** Is Visible */
  is_visible: boolean;
}

/**
 * PrimaryProviderResponse
 * Confirmation of setting the primary authentication provider.
 */
export interface PrimaryProviderResponse {
  /** Message */
  message: string;
  /** Primary Provider */
  primary_provider: string;
}

/**
 * ProviderConfigDeletionResponse
 * Acknowledgement that provider-config deletion was scheduled (async cleanup).
 */
export interface ProviderConfigDeletionResponse {
  /** Message */
  message: string;
  /** Config Id */
  config_id: string;
  /** Job Id */
  job_id?: string | null;
  /** Status */
  status: string;
}

/**
 * ProviderConfigSyncStatus
 * Aggregated sync status across all connections under a provider config.
 *
 * The totals are what the provider card shows at a glance: how many
 * documents this source holds, how much they weigh, and how many files the
 * last run skipped or could not process. They are summed over the
 * connections so the card does not have to add up anything itself.
 */
export interface ProviderConfigSyncStatus {
  /** Config Id */
  config_id: string;
  /** Connection Count */
  connection_count: number;
  /** Connections */
  connections?: ConnectionSyncStatusDetail[];
  /**
   * Document Count
   * @default 0
   */
  document_count?: number;
  /**
   * Total Size Bytes
   * @default 0
   */
  total_size_bytes?: number;
  /**
   * Skipped Files
   * @default 0
   */
  skipped_files?: number;
  /**
   * Unchanged Files
   * @default 0
   */
  unchanged_files?: number;
  /**
   * Failed Files
   * @default 0
   */
  failed_files?: number;
}

/**
 * QdrantCollectionResponse
 * Response model for Qdrant collection operations.
 */
export interface QdrantCollectionResponse {
  /** Status */
  status: string;
  /** Message */
  message: string;
  /** Collection Name */
  collection_name: string;
  /** Points Count */
  points_count: number;
}

/**
 * RecipientSearchResponse
 * Combined user+group recipient search; echoes the query and searched types.
 *
 * Extends the ``{results, total}`` envelope with the ``query`` string and the
 * list of ``types`` searched, which the recipient autocomplete endpoint returns
 * alongside the results.
 */
export interface RecipientSearchResponse {
  /** Results */
  results?: Record<string, any>[];
  /** Total */
  total: number;
  /** Query */
  query: string;
  /** Types */
  types?: string[];
}

/**
 * RetrievalKillSwitchRequest
 * Request body for the retrieval kill-switch endpoint.
 *
 * ``enabled=true``  → retrieval works normally (clears / sets key to "false").
 * ``enabled=false`` → retrieval is halted; all chat endpoints return 503.
 */
export interface RetrievalKillSwitchRequest {
  /** Enabled */
  enabled: boolean;
}

/**
 * SMTPConfigRequest
 * SMTP configuration request model.
 *
 * ``smtp_password`` is write-only and optional: send a non-empty value to set
 * or change it; omit it (or send an empty string) to keep the stored password
 * unchanged. The current password is never returned by the API, so the UI
 * cannot (and must not) echo it back on save.
 */
export interface SMTPConfigRequest {
  /**
   * Email Provider
   * @default "smtp_generic"
   */
  email_provider?: string;
  /** Smtp Host */
  smtp_host: string;
  /**
   * Smtp Port
   * @default 587
   */
  smtp_port?: number;
  /** Smtp User */
  smtp_user: string;
  /** Smtp Password */
  smtp_password?: string | null;
  /**
   * Smtp From Email
   * @format email
   */
  smtp_from_email: string;
  /**
   * Smtp Use Tls
   * @default true
   */
  smtp_use_tls?: boolean;
  /**
   * Smtp From Name
   * @default "Smarty System"
   */
  smtp_from_name?: string;
  /**
   * Send Welcome Email
   * @default false
   */
  send_welcome_email?: boolean;
}

/**
 * SMTPConfigResponse
 * SMTP configuration response model.
 */
export interface SMTPConfigResponse {
  /** Source */
  source: string;
  /** Config */
  config: Record<string, any>;
  /** Error */
  error?: string | null;
}

/**
 * SMTPConfigurationResponse
 * Response model for SMTP configuration.
 */
export interface SMTPConfigurationResponse {
  /** Status */
  status: string;
  /** Host */
  host: string;
  /** Port */
  port: number;
  /** Use Tls */
  use_tls: boolean;
  /** From Email */
  from_email: string;
  /** From Name */
  from_name: string;
}

/**
 * SearchRequest
 * Model for document search requests.
 */
export interface SearchRequest {
  /** Query */
  query: string;
  /** Filter */
  filter?: Record<string, string | number | boolean>;
  /**
   * Limit
   * @default 10
   */
  limit?: number;
}

/**
 * SearchResponse
 * Model for document search responses.
 */
export interface SearchResponse {
  /** Query */
  query: string;
  /** Results */
  results: SearchResult[];
  /** Total */
  total: number;
}

/**
 * SearchResult
 * Model for document search results.
 */
export interface SearchResult {
  /** Document Id */
  document_id: string;
  /** Title */
  title: string;
  /** Url */
  url?: string | null;
  /** Visibility */
  visibility: string;
  /** Relevance Score */
  relevance_score: number;
  /** Content Preview */
  content_preview: string;
}

/**
 * SearchResultsResponse
 * Generic ``{results, total}`` envelope for autocomplete/search endpoints.
 *
 * ``results`` items are intentionally loosely typed (``dict``): the
 * user/group/recipient search endpoints return heterogeneous item dicts
 * (different fields per result kind, with a ``type`` discriminator). Typing the
 * envelope replaces the previous ``any`` schema without filtering item fields;
 * item models can be tightened later if a stricter client contract is needed.
 */
export interface SearchResultsResponse {
  /** Results */
  results?: Record<string, any>[];
  /** Total */
  total: number;
}

/**
 * SetPrimaryProviderRequest
 * Request to set primary auth provider.
 */
export interface SetPrimaryProviderRequest {
  /** Provider type to set as primary */
  provider_type: AuthProviderType;
}

/**
 * SettingsUpdate
 * Model for settings updates.
 */
export interface SettingsUpdate {
  /** Branding */
  branding?: Record<string, any> | null;
  /** Features */
  features?: Record<string, any> | null;
  /** Limits */
  limits?: Record<string, any> | null;
  /** Security */
  security?: Record<string, any> | null;
}

/**
 * SharedFolderImportRequest
 * Request to import files from a shared folder.
 */
export interface SharedFolderImportRequest {
  /** Url */
  url: string;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Selected Files */
  selected_files?: string[] | null;
  /**
   * Visibility
   * @default "private"
   */
  visibility?: string | null;
  /**
   * Shared With Users
   * @default []
   */
  shared_with_users?: string[] | null;
  /**
   * Shared With Groups
   * @default []
   */
  shared_with_groups?: string[] | null;
}

/**
 * SharedFolderValidateRequest
 * Request to validate a shared folder link.
 */
export interface SharedFolderValidateRequest {
  /** Url */
  url: string;
}

/**
 * StatusResponse
 * Standard response for operations that return a simple status.
 */
export interface StatusResponse {
  /**
   * Status
   * @default "success"
   */
  status?: string;
  /** Message */
  message: string;
  /** Details */
  details?: Record<string, string | number | boolean>;
}

/**
 * SystemCleanupResponse
 * Response model for system cleanup operations.
 */
export interface SystemCleanupResponse {
  /** Status */
  status: string;
  /** Message */
  message: string;
  /** Mongodb Deleted */
  mongodb_deleted: number;
  /** Qdrant Deleted */
  qdrant_deleted: number;
  /** S3 Deleted */
  s3_deleted: number;
}

/**
 * SystemStatusResponse
 * Response model for system status.
 */
export interface SystemStatusResponse {
  /** Status */
  status: string;
  /** Version */
  version: string;
  /** Uptime */
  uptime: string;
  /** Database Connected */
  database_connected: boolean;
  /** Redis Connected */
  redis_connected: boolean;
  /** Qdrant Connected */
  qdrant_connected: boolean;
  /** Total Users */
  total_users: number;
  /** Total Documents */
  total_documents: number;
}

/**
 * TestEmailRequest
 * Test email request model.
 */
export interface TestEmailRequest {
  /**
   * Email
   * @format email
   */
  email: string;
}

/**
 * TextExtractionRequest
 * Request model for text extraction configuration.
 */
export interface TextExtractionRequest {
  /** Text extraction provider types. */
  provider: TextExtractionProviderType;
  /**
   * Timeout
   * @default 60
   */
  timeout?: number;
  /**
   * Max Retries
   * @default 3
   */
  max_retries?: number;
  /**
   * Ocr Enabled
   * @default true
   */
  ocr_enabled?: boolean;
  /**
   * Ocr Language
   * @default "de"
   */
  ocr_language?: string;
  /**
   * Ocr Per Page Enabled
   * @default false
   */
  ocr_per_page_enabled?: boolean;
  /**
   * Ocr Per Page Min Chars
   * @default 64
   */
  ocr_per_page_min_chars?: number;
  /**
   * Ocr Page Detection Enabled
   * @default true
   */
  ocr_page_detection_enabled?: boolean;
  /**
   * Ocr Page Min Chars
   * @default 64
   */
  ocr_page_min_chars?: number;
  /**
   * Ocr Page Min Image Coverage
   * @default 0.3
   */
  ocr_page_min_image_coverage?: number;
  /**
   * Ocr Language Auto
   * @default true
   */
  ocr_language_auto?: boolean;
  /**
   * Ocr Render Scale
   * @default 3
   */
  ocr_render_scale?: number;
  /**
   * Ocr Engine
   * @default "rapidocr"
   */
  ocr_engine?: string;
  /**
   * Ocr Onnx Device
   * @default "cpu"
   */
  ocr_onnx_device?: string;
  /**
   * Ocr Dictionary Correction Enabled
   * @default true
   */
  ocr_dictionary_correction_enabled?: boolean;
  /**
   * Ocr Vocabulary Path
   * @default ""
   */
  ocr_vocabulary_path?: string;
  /**
   * Ocr Second Pass Enabled
   * @default true
   */
  ocr_second_pass_enabled?: boolean;
  /**
   * Ocr Second Pass Min P10
   * @default 0.6
   */
  ocr_second_pass_min_p10?: number;
  /**
   * Ocr Max Pages
   * @default 150
   */
  ocr_max_pages?: number;
  /**
   * Ocr Noise Filter Enabled
   * @default true
   */
  ocr_noise_filter_enabled?: boolean;
  /**
   * Ocr Deskew Enabled
   * @default true
   */
  ocr_deskew_enabled?: boolean;
  /**
   * Ocr Deskew Min Angle
   * @default 1
   */
  ocr_deskew_min_angle?: number;
  /**
   * Ocr Orientation Enabled
   * @default true
   */
  ocr_orientation_enabled?: boolean;
  /**
   * Extract Tables
   * @default true
   */
  extract_tables?: boolean;
  /**
   * Extract Images
   * @default false
   */
  extract_images?: boolean;
  /**
   * Preserve Layout
   * @default true
   */
  preserve_layout?: boolean;
  /**
   * Provider Config
   * @default {}
   */
  provider_config?: Record<string, any>;
  /**
   * Display Name
   * @default ""
   */
  display_name?: string;
  /**
   * Description
   * @default ""
   */
  description?: string;
}

/**
 * TextExtractionResponse
 * Response model for text extraction configuration.
 */
export interface TextExtractionResponse {
  /** Text extraction provider types. */
  provider: TextExtractionProviderType;
  /** Timeout */
  timeout: number;
  /** Max Retries */
  max_retries: number;
  /** Ocr Enabled */
  ocr_enabled: boolean;
  /** Ocr Language */
  ocr_language: string;
  /**
   * Ocr Per Page Enabled
   * @default false
   */
  ocr_per_page_enabled?: boolean;
  /**
   * Ocr Per Page Min Chars
   * @default 64
   */
  ocr_per_page_min_chars?: number;
  /**
   * Ocr Page Detection Enabled
   * @default true
   */
  ocr_page_detection_enabled?: boolean;
  /**
   * Ocr Page Min Chars
   * @default 64
   */
  ocr_page_min_chars?: number;
  /**
   * Ocr Page Min Image Coverage
   * @default 0.3
   */
  ocr_page_min_image_coverage?: number;
  /**
   * Ocr Language Auto
   * @default true
   */
  ocr_language_auto?: boolean;
  /**
   * Ocr Render Scale
   * @default 3
   */
  ocr_render_scale?: number;
  /**
   * Ocr Engine
   * @default "rapidocr"
   */
  ocr_engine?: string;
  /**
   * Ocr Onnx Device
   * @default "cpu"
   */
  ocr_onnx_device?: string;
  /**
   * Ocr Dictionary Correction Enabled
   * @default true
   */
  ocr_dictionary_correction_enabled?: boolean;
  /**
   * Ocr Vocabulary Path
   * @default ""
   */
  ocr_vocabulary_path?: string;
  /**
   * Ocr Second Pass Enabled
   * @default true
   */
  ocr_second_pass_enabled?: boolean;
  /**
   * Ocr Second Pass Min P10
   * @default 0.6
   */
  ocr_second_pass_min_p10?: number;
  /**
   * Ocr Max Pages
   * @default 150
   */
  ocr_max_pages?: number;
  /**
   * Ocr Noise Filter Enabled
   * @default true
   */
  ocr_noise_filter_enabled?: boolean;
  /**
   * Ocr Deskew Enabled
   * @default true
   */
  ocr_deskew_enabled?: boolean;
  /**
   * Ocr Deskew Min Angle
   * @default 1
   */
  ocr_deskew_min_angle?: number;
  /**
   * Ocr Orientation Enabled
   * @default true
   */
  ocr_orientation_enabled?: boolean;
  /** Extract Tables */
  extract_tables: boolean;
  /** Extract Images */
  extract_images: boolean;
  /** Preserve Layout */
  preserve_layout: boolean;
  /** Provider Config */
  provider_config: Record<string, any>;
  /** Display Name */
  display_name: string;
  /** Description */
  description: string;
  /** Is Active */
  is_active: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Created By */
  created_by: string;
}

/**
 * UnlinkIdentityResponse
 * Result of unlinking an external identity from the account.
 */
export interface UnlinkIdentityResponse {
  /** Status */
  status: string;
  /** Provider Key */
  provider_key: string;
}

/**
 * UpdateConversationRequest
 * Request model for updating conversation with validation.
 */
export interface UpdateConversationRequest {
  /**
   * Title
   * New conversation title
   */
  title?: string | null;
  /**
   * Is Archived
   * Archive status
   */
  is_archived?: boolean | null;
  /**
   * Tools Enabled
   * Whether MCP tools are enabled for this conversation
   */
  tools_enabled?: boolean | null;
}

/**
 * UploadCapabilitiesResponse
 * The server's accepted upload formats and limits, read by the upload UI.
 */
export interface UploadCapabilitiesResponse {
  /** Allowed Extensions */
  allowed_extensions?: string[];
  /** Accept */
  accept: string;
  /** Image Upload Enabled */
  image_upload_enabled: boolean;
  /** Max File Size Mb */
  max_file_size_mb: number;
}

/**
 * User
 * Model for user data response.
 */
export interface User {
  /** Username */
  username: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /** Full Name */
  full_name?: string | null;
  /**
   * User role enumeration with hierarchical permissions (set theory).
   * @default "standard"
   */
  role?: UserRole;
  /** Id */
  id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Updated At */
  updated_at?: string | null;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /**
   * Email Verified
   * @default false
   */
  email_verified?: boolean;
  /**
   * Needs Admin Approval
   * @default false
   */
  needs_admin_approval?: boolean;
}

/**
 * UserBasicInfo
 * Basic user info model for non-admin users (only essential fields).
 */
export interface UserBasicInfo {
  /** Id */
  id: string;
  /** Username */
  username: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /** Full Name */
  full_name?: string | null;
}

/**
 * UserChatPreference
 * Model for user chat model preference.
 */
export interface UserChatPreference {
  /** Config Id */
  config_id: string;
}

/**
 * UserCreate
 * Model for user creation.
 */
export interface UserCreate {
  /** Username */
  username: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /** Full Name */
  full_name?: string | null;
  /**
   * User role enumeration with hierarchical permissions (set theory).
   * @default "standard"
   */
  role?: UserRole;
  /** Password */
  password: string;
}

/**
 * UserListResponse
 * Response model for a paginated user list.
 *
 * Items are ``User | UserBasicInfo``: the list endpoint returns the full
 * ``User`` shape to admin requesters and the trimmed ``UserBasicInfo`` to
 * non-admins (role-based field filtering), so the union keeps both lossless.
 */
export interface UserListResponse {
  /** Users */
  users: (User | UserBasicInfo)[];
  /** Total */
  total: number;
}

/**
 * UserPermissions
 * User permissions mapping for frontend.
 */
export interface UserPermissions {
  /** Permission detail for a specific feature. */
  dashboard: PermissionDetail;
  /** Permission detail for a specific feature. */
  chat: PermissionDetail;
  /** Permission detail for a specific feature. */
  documents: PermissionDetail;
  /** Permission detail for a specific feature. */
  settings: PermissionDetail;
  /** Permission detail for a specific feature. */
  my_groups: PermissionDetail;
  /** Permission detail for a specific feature. */
  public_groups: PermissionDetail;
  /** Permission detail for a specific feature. */
  users: PermissionDetail;
  /** Extended permission detail for groups feature with granular actions. */
  groups: GroupsPermissionDetail;
  /** Permission detail for a specific feature. */
  chat_config: PermissionDetail;
  /** Permission detail for a specific feature. */
  embedding_config: PermissionDetail;
  /** Permission detail for a specific feature. */
  text_extraction_config: PermissionDetail;
  /** Permission detail for a specific feature. */
  document_sources: PermissionDetail;
  /** Permission detail for a specific feature. */
  smtp_config: PermissionDetail;
  /** Permission detail for a specific feature. */
  system_management: PermissionDetail;
}

/**
 * UserRegister
 * Model for user self-registration.
 */
export interface UserRegister {
  /** Username */
  username: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /** Password */
  password: string;
  /** Full Name */
  full_name?: string | null;
  /** Language */
  language?: string | null;
}

/**
 * UserUpdate
 * Model for user updates.
 */
export interface UserUpdate {
  /** Email */
  email?: string | null;
  /** Full Name */
  full_name?: string | null;
  role?: UserRole | null;
  /** Password */
  password?: string | null;
  /** Active */
  active?: boolean | null;
  /** Email Verified */
  email_verified?: boolean | null;
}

/**
 * ValidateFolderUrlRequest
 * Request to validate a shared folder URL.
 */
export interface ValidateFolderUrlRequest {
  /** Url */
  url: string;
  /** Password */
  password?: string | null;
}

/**
 * ValidateFolderUrlResponse
 * Response from folder URL validation.
 */
export interface ValidateFolderUrlResponse {
  /** Is Valid */
  is_valid: boolean;
  /** Provider */
  provider: string | null;
  /** Folder Info */
  folder_info: Record<string, any> | null;
  /** Files */
  files: Record<string, any>[] | null;
  /** Error Message */
  error_message?: string | null;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
  /** Input */
  input?: any;
  /** Context */
  ctx?: object;
}

/**
 * WhoAmIResponse
 * Response model for who_am_i endpoint with permissions.
 */
export interface WhoAmIResponse {
  /** User Id */
  user_id: string;
  /** Username */
  username: string;
  /** Email */
  email?: string | null;
  /** Full Name */
  full_name?: string | null;
  /** User role enumeration with hierarchical permissions (set theory). */
  role: UserRole;
  /** User permissions mapping for frontend. */
  permissions: UserPermissions;
  /** Deleted At */
  deleted_at?: string | null;
  /** Deletion Requested By */
  deletion_requested_by?: string | null;
  /**
   * Email Verified
   * @default false
   */
  email_verified?: boolean;
  /**
   * Needs Admin Approval
   * @default false
   */
  needs_admin_approval?: boolean;
}

/** ErrorResponse */
export interface ErrorResponse {
  /** Detail */
  detail?: string;
}

// --- Hand-maintained: not part of the OpenAPI schema ---
// yarn generate-api ueberschreibt diese Datei und wirft alles hier weg.
// Nach jedem Lauf wiederherstellen.

export type { ChatResponse, ChatSource, LocatorRegion, SourceLocator } from './chatTypes';
/**
 * ToolReference
 * A `[[TOOL:<server>:<ref>]]` citation reference to an MCP tool result.
 *
 * Reserved for the parallel tool-citation channel (plan section 7): a
 * dedicated marker family alongside the existing numeric `[[N]]` footnotes,
 * NOT a repurposing of `citation_id`. Not yet wired into `MarkdownMessage.tsx`
 * or any renderer -- that lands with the prompt/citation-regime package.
 *
 * NOTE: hand-maintained, forward-declared ahead of its consumer.
 */
export interface ToolReference {
  /** Server Key: matches `ToolStep.server_key` / the `mcp_server_configs` key. */
  server_key: string;
  /** Ref: opaque reference string from the tool source's sanitized metadata (grammar: `[A-Za-z0-9_.-]{1,64}`). */
  ref: string;
}

/**
 * ToolStep
 * A single MCP tool invocation surfaced during (or after) a chat turn.
 *
 * Frontend-accumulated from the SSE `tool_call` / `tool_result` /
 * `tool_steps_discarded` events (see `sseFrameParser.ts`): a `tool_call`
 * opens a step in `status: "running"`; the matching `tool_result` (same
 * `call_id`) resolves it. `arguments` and `summary` are the SAME sanitized,
 * capped strings the backend puts on the wire (S11) -- never render them
 * through the markdown renderer, only as plain text.
 *
 * NOTE: hand-maintained. Not a server-generated type: the backend does not
 * yet persist tool steps (mcp_tool_steps is a later package), so a message
 * loaded from history will not carry these until that lands.
 */
export interface ToolStep {
  /** Call Id: correlates the `tool_call` and `tool_result` events for one invocation. */
  call_id: string;
  /** Server Key: the `mcp_server_configs` key the tool was invoked on. */
  server_key: string;
  /** Tool Name */
  tool_name: string;
  /** Arguments: sanitized, capped `arguments_redacted` string -- plain text only. */
  arguments: string;
  /** Running until the matching `tool_result` arrives. */
  status: "running" | "succeeded" | "failed" | "refused";
  /** Summary: sanitized, capped `result_summary` string -- plain text only; absent while running. */
  summary?: string | null;
  /**
   * Discarded: set once a `tool_steps_discarded` event marks this turn's
   * already-streamed steps as void (the turn was subsequently gated or
   * errored, B1). Steps stay visible but visually marked, never removed.
   */
  discarded?: boolean;
}
